import { headers } from "../../App/Axios"
import HTTPService from "../../App/HTTPService"

export type RegisterMobileDevicePayload = {
    fcm_token: string
    platform: "ios" | "android" | "web"
    device_id?: string
    app_version?: string
    notifications_enabled?: boolean
}

export const registerMobileDeviceRequest = (payload: RegisterMobileDevicePayload) => {
    return HTTPService.post(`/user/mobile-devices/register/`, payload, headers)
}

export const unregisterMobileDeviceRequest = (fcmToken: string) => {
    return HTTPService.post(
        `/user/mobile-devices/unregister/`,
        { fcm_token: fcmToken },
        headers
    )
}
